/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const ChatDocumentsSchema: Tool[] = [
  {
    toolSpec: {
      name: 'add_chat_document',
      description:
        'Create a new document in this conversation: a written markdown document, or a spreadsheet with format xlsx or csv. The draft is previewed in the chat and opened on its own page; it is not saved to the Documents library unless the user exports it. Markdown content starts with a single # title line; spreadsheet content is the complete table.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            title: {
              type: 'string',
              maxLength: 120,
              description: 'Short display title for the document.'
            },
            content: {
              type: 'string',
              description:
                'Complete body. Markdown: start with a single # heading, then ## sections. Spreadsheet: a markdown table with a header row (TSV or CSV also accepted).'
            },
            format: {
              type: 'string',
              enum: ['markdown', 'xlsx', 'csv'],
              default: 'markdown',
              description:
                'markdown for a written document; xlsx for a spreadsheet, or csv only when the user asks for CSV.'
            }
          },
          required: ['title', 'content']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'edit_chat_document',
      description:
        'Overwrite the complete content of an existing document in this conversation: its markdown, or the table of a spreadsheet draft. Include the full document, not a diff; read it first so unchanged sections are preserved. A filled template draft (Word or PDF) is changed by calling fill_template again with its draft_id instead. If the user already saved it to the Documents library, the call fails with saved_document_path; edit that library document instead.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Document UUID.'
            },
            content: {
              type: 'string',
              description:
                'Complete replacement body: markdown, or a markdown table for a spreadsheet draft.'
            },
            title: {
              type: 'string',
              maxLength: 120,
              description: 'Optional replacement title.'
            }
          },
          required: ['id', 'content']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'read_chat_document',
      description:
        'Return one document in this conversation with its metadata: the stored markdown, or the extracted text of a file draft (a spreadsheet as a markdown table). Use before revising a document or when a document ID is provided directly.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Document UUID.'
            }
          },
          required: ['id']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'list_chat_documents',
      description:
        'List documents in this conversation as IDs, titles, export state, and update times. Content is omitted; call read_chat_document when the body is needed.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {},
          required: []
        }
      }
    }
  }
]

export enum ChatDocumentsToolNames {
  AddChatDocument = 'add_chat_document',
  EditChatDocument = 'edit_chat_document',
  ReadChatDocument = 'read_chat_document',
  ListChatDocuments = 'list_chat_documents'
}
